var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _path13, _path14, _circle4, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsleep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 223,
    viewBox: "15 4 140 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 114C152 148.794 121.779 177 84.5 177C47.2208 177 17 148.794 17 114C17 79.2061 47.2208 51 84.5 51C121.779 51 152 79.2061 152 114Z",
    fill: "url(#paint0_linear_2305_753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37H89V53H79V37Z",
    fill: "url(#paint1_linear_2305_753)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 25,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 182C124.765 182 157 152.003 157 115C157 92.6269 145.216 72.8153 127.108 60.6465C125.427 59.5166 123.428 58.9736 121.402 58.9736H48.5978C46.572 58.9736 44.5734 59.5166 42.892 60.6465C24.7843 72.8153 13 92.6269 13 115C13 152.003 45.2355 182 85 182Z",
    fill: "url(#paint2_linear_2305_753)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7621,
    cy: 157.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 33.7621 157.972)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8582 167.846C47.5715 165.093 45.306 158.461 39.7982 153.034C34.2903 147.608 27.6258 145.441 24.9125 148.195C22.1993 150.949 24.4647 157.581 29.9725 163.007C35.4804 168.434 42.1449 170.6 44.8582 167.846ZM40.1264 164.316C41.8528 162.563 40.4113 158.344 36.9067 154.891C33.4021 151.438 29.1616 150.059 27.4351 151.812C25.7087 153.564 27.1502 157.784 30.6548 161.237C34.1594 164.689 38.4 166.068 40.1264 164.316Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9572 160.302L41.05 156.373L33.1926 150.187L30.0998 154.116L37.9572 160.302ZM29.5642 212.752C30.8078 215.218 33.8146 216.208 36.2802 214.965C38.7457 213.721 39.7363 210.714 38.4927 208.249L29.5642 212.752ZM30.0998 154.116C26.3146 158.924 24.4141 164.995 23.4239 169.834C22.4179 174.75 22.2412 178.958 22.2412 180.5L32.2412 180.5C32.2412 179.493 32.3749 175.972 33.2209 171.838C34.0827 167.627 35.5758 163.327 37.9572 160.302L30.0998 154.116ZM22.2412 180.5C22.2412 189.115 24.8565 203.418 29.5642 212.752L38.4927 208.249C34.6259 200.582 32.2412 187.885 32.2412 180.5L22.2412 180.5Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9193 160.349L41.0592 156.458L33.2768 150.178L30.1369 154.069L37.9193 160.349ZM27.2412 179.5L32.2412 179.5L27.2412 179.5ZM27.9248 212.343C28.6661 215.003 31.4235 216.558 34.0835 215.817C36.7436 215.075 38.299 212.318 37.5577 209.658L27.9248 212.343ZM37.5577 209.658C37.4707 209.346 37.3838 209.031 37.2971 208.714L27.6519 211.355C27.7427 211.687 27.8337 212.016 27.9248 212.343L37.5577 209.658ZM34.1424 195.422C34.0169 194.786 33.8959 194.151 33.7801 193.519L23.9441 195.323C24.0683 196 24.1975 196.679 24.3313 197.357L34.1424 195.422ZM32.2508 180.395C32.2444 180.091 32.2412 179.792 32.2412 179.5L22.2412 179.5C22.2412 179.866 22.2452 180.235 22.2531 180.606L32.2508 180.395ZM32.2412 179.5C32.2412 179.036 32.2441 178.569 32.2519 178.096L22.2533 177.93C22.2443 178.471 22.2412 178.996 22.2412 179.5L32.2412 179.5ZM37.1585 161.339C37.3993 161.01 37.6526 160.679 37.9193 160.349L30.1369 154.069C29.7694 154.525 29.418 154.983 29.0821 155.443L37.1585 161.339Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4478 159.209C43.3858 157.155 41.8078 155.014 39.7982 153.034C36.6815 149.964 33.1945 147.937 30.2626 147.255L31.4998 151.398C33.2149 151.955 35.1529 153.163 36.9067 154.891C38.313 156.276 39.3871 157.785 40.0576 159.209H44.4478Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7969,
    cy: 209.555,
    r: 10.625,
    transform: "rotate(-30.6263 33.7969 209.555)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 146.006 154.694)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.148 167.846C121.434 165.093 123.7 158.461 129.208 153.034C134.716 147.608 141.38 145.441 144.093 148.195C146.807 150.949 144.541 157.581 139.033 163.007C133.525 168.434 126.861 170.6 124.148 167.846ZM128.879 164.316C127.153 162.563 128.595 158.344 132.099 154.891C135.604 151.438 139.844 150.059 141.571 151.812C143.297 153.564 141.856 157.784 138.351 161.237C134.846 164.689 130.606 166.068 128.879 164.316Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.049 160.302L127.956 156.373L135.813 150.187L138.906 154.116L131.049 160.302ZM136.835 218.643C134.271 219.668 131.361 218.421 130.335 215.857C129.31 213.293 130.557 210.383 133.121 209.358L136.835 218.643ZM138.906 154.116C142.674 158.903 144.944 165.535 146.295 171.406C147.668 177.379 148.241 183.244 148.241 187L138.241 187C138.241 184.049 137.766 178.936 136.549 173.648C135.31 168.259 133.447 163.349 131.049 160.302L138.906 154.116ZM148.241 187C148.241 191.064 146.586 198.197 144.834 204.007C143.926 207.015 142.909 209.945 141.916 212.252C141.425 213.391 140.884 214.511 140.303 215.45C140.014 215.917 139.647 216.451 139.198 216.95C138.809 217.382 138.027 218.166 136.835 218.643L133.121 209.358C132.241 209.71 131.797 210.224 131.767 210.257C131.677 210.358 131.69 210.364 131.798 210.189C132.011 209.845 132.33 209.227 132.732 208.295C133.521 206.462 134.414 203.923 135.26 201.119C137.014 195.304 138.241 189.437 138.241 187L148.241 187Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.049 160.302L127.956 156.373L135.813 150.187L138.906 154.116L131.049 160.302ZM143.241 186L138.241 186L143.241 186ZM140.16 214.84C138.868 217.28 135.842 218.211 133.402 216.919C130.961 215.627 130.03 212.601 131.322 210.161L140.16 214.84ZM131.322 210.161C131.443 209.932 131.564 209.7 131.683 209.465L140.597 213.997C140.454 214.28 140.308 214.561 140.16 214.84L131.322 210.161ZM135.827 199C135.986 198.479 136.138 197.959 136.283 197.442L145.911 200.144C145.746 200.732 145.573 201.323 145.393 201.915L135.827 199ZM138.228 186.68C138.237 186.44 138.241 186.213 138.241 186L148.241 186C148.241 186.345 148.234 186.695 148.221 187.048L138.228 186.68ZM138.241 186C138.241 185.746 138.238 185.474 138.23 185.186L148.227 184.925C148.236 185.295 148.241 185.654 148.241 186L138.241 186ZM136.533 173.082C136.396 172.518 136.25 171.954 136.095 171.392L145.735 168.734C145.919 169.399 146.09 170.062 146.251 170.723L136.533 173.082ZM131.488 160.887C131.343 160.684 131.196 160.489 131.049 160.302L138.906 154.116C139.147 154.422 139.381 154.734 139.608 155.05L131.488 160.887Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.558 159.209C125.62 157.155 127.198 155.014 129.208 153.034C132.324 149.964 135.811 147.937 138.743 147.255L137.506 151.398C135.791 151.955 133.853 153.163 132.099 154.891C130.693 156.276 129.619 157.785 128.948 159.209H124.558Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.797,
    cy: 215.555,
    r: 10.625,
    transform: "rotate(-30.6263 131.797 215.555)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.2412,
    y: 155,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2412,
    y: 155,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7412,
    y: 152,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2412,
    y: 86,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 68.4997C73.7 68.8997 55.3333 62.3331 47.5 58.9997C48.5 38.1664 57.8 -1.30025 87 7.49975C116.2 16.2997 122.167 45.4997 121.5 58.9997C113.667 61.9997 95.3 68.0997 84.5 68.4997Z",
    fill: "#19569B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 50C63.8333 55.3333 98.9 62.6 116.5 49M50.5 38.5C63.8333 43.1667 94.8 49.7 112 38.5M53.5 29C63.5 32.5 88 34.9 104 28.5M57.5 20.5C62.5 23.5 81.7 22.9 94.5 20.5",
    stroke: "white",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0006 13.9997C69.8339 15.6663 67.6 21 84 17C96.5 21.5 105.5 29 111.5 44C123.5 72 131.659 112.559 135.5 138.5C137.5 138.5 136 139 138.001 138.5C135.501 -24.0003 76.0001 6.49968 72.5001 7.49968C69.7001 8.29968 70.3337 12.1663 71.0006 13.9997Z",
    fill: "#19569B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 137.5,
    r: 5.5,
    fill: "#194981"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 61C114.833 48.5 103.2 21.9 88 19.5",
    stroke: "#06356C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50 115C50 116.313 50.2587 117.614 50.7612 118.827C51.2638 120.04 52.0003 121.142 52.9289 122.071C53.8575 123 54.9599 123.736 56.1732 124.239C57.3864 124.741 58.6868 125 60 125C61.3132 125 62.6136 124.741 63.8268 124.239C65.0401 123.736 66.1425 123 67.0711 122.071C67.9997 121.142 68.7362 120.04 69.2388 118.827C69.7413 117.614 70 116.313 70 115",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115C100 116.313 100.259 117.614 100.761 118.827C101.264 120.04 102 121.142 102.929 122.071C103.858 123 104.96 123.736 106.173 124.239C107.386 124.741 108.687 125 110 125C111.313 125 112.614 124.741 113.827 124.239C115.04 123.736 116.142 123 117.071 122.071C118 121.142 118.736 120.04 119.239 118.827C119.741 117.614 120 116.313 120 115",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_753",
    x1: 84.5,
    y1: 37,
    x2: 84.5,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2305_753",
    x1: 84.5,
    y1: 37,
    x2: 84.5,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2305_753",
    x1: 85,
    y1: 47.9999,
    x2: 85,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsleep);
export default __webpack_public_path__ + "static/media/asleep.d4f5efe6d5b6f0b00bbd34ba2cc8656f.svg";
export { ForwardRef as ReactComponent };